import React from "react";
import classes from "./WhiteBlocksList.module.scss";

export interface ITrustedPartnerBlock {
  title: string;
  icon: string;
}

const WhiteBlocksList: React.FC<{
  title: string;
  blocks: ITrustedPartnerBlock[];
}> = ({ title, blocks }) => {
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{title}</h2>
      <div className={`${classes["blocks-container"]} ${classes[`blocks-container--${blocks.length}`]}`}>
        {blocks.map((block) => (
          <div className={classes.block} key={block.title}>
            <img src={block.icon} alt={block.title} />
            <span>{block.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhiteBlocksList;
